module.exports = __webpack_public_path__ + "img/Xd.03ea7304.png";